import React from 'react';
import loadable from '@loadable/component';

import aboutPageContent from './aboutPageContent.json';
// empavision:ext-multilanguage — translate the hardcoded local page (same as LandingPage)
import { useTranslatedPageContent } from '../../extensions/empavision-enrichments/packages/ext-multilanguage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Hard-coded About page (aboutPageContent.json), same rationale as LandingPage:
// Console's page editor can only produce its built-in section templates, which
// cannot express this design (photo hero, full-bleed CTA band, prose blocks).
const AboutPage = () => {
  return <PageBuilder pageAssetsData={useTranslatedPageContent(aboutPageContent)} />;
};

export default AboutPage;
